import * as React from "react";
import { Link } from "components/common/router";
import Routes from "routing/Routes";
import AppConfig from "util/AppConfig";
import HideOnCloud from "util/conditional/HideOnCloud";
import { NodesStore } from "stores/nodes/NodesStore";
import connect from "stores/connect";
import Icon from "./Icon";
import Spinner from "./Spinner";
class LinkToNode extends React.PureComponent {
  render() {
    const { nodes } = this.props;
    if (!nodes) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    const node = nodes[this.props.nodeId];
    if (node) {
      const iconName = node.is_leader ? "star" : "fork_right";
      const iconClass = node.is_leader ? "leader-node" : "";
      const iconTitle = node.is_leader ? "This is the leader node in the cluster" : "";
      const content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: iconName, className: iconClass, title: iconTitle }), " ", node.short_node_id, /* @__PURE__ */ React.createElement(HideOnCloud, null, " / ", node.hostname));
      if (AppConfig.isCloud()) {
        return content;
      }
      return /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.CLUSTER.NODE_SHOW(this.props.nodeId) }, content);
    }
    return /* @__PURE__ */ React.createElement("i", null, "Unknown Node");
  }
}
LinkToNode.defaultProps = {
  nodes: void 0
};
export default connect(LinkToNode, { nodeStore: NodesStore }, ({ nodeStore, ...rest }) => ({
  ...rest,
  nodes: nodeStore.nodes
}));
